/*
* Project: LegalPlace assistant
* File: src/components/modal.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PreviewRow from './preview_row';
import { generateId1 } from './utils/misc';
// import actions
import { togglePreview } from '../redux/actions/toggle_preview';
import { _lp } from '../logic/wording';
import lpApp from '../app/lp_app';

let numberOfAll = 0;

// calculation of page numbers
const PAGE_WIDTH = 684;

function getPageNumber(width) {
  return Math.ceil(width / PAGE_WIDTH);
}
function getPageToMargin(page) {
  return -(PAGE_WIDTH * page);
}

// ██████╗ ██████╗ ███████╗██████╗  █████╗ ██████╗ ███████╗    ██████╗  ██████╗ ███╗   ███╗
// ██╔══██╗██╔══██╗██╔════╝██╔══██╗██╔══██╗██╔══██╗██╔════╝    ██╔══██╗██╔═══██╗████╗ ████║
// ██████╔╝██████╔╝█████╗  ██████╔╝███████║██████╔╝█████╗      ██║  ██║██║   ██║██╔████╔██║
// ██╔═══╝ ██╔══██╗██╔══╝  ██╔═══╝ ██╔══██║██╔══██╗██╔══╝      ██║  ██║██║   ██║██║╚██╔╝██║
// ██║     ██║  ██║███████╗██║     ██║  ██║██║  ██║███████╗    ██████╔╝╚██████╔╝██║ ╚═╝ ██║
// ╚═╝     ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝    ╚═════╝  ╚═════╝ ╚═╝     ╚═╝
//

function placeModalInDOM(exitYo) {
  document.getElementById('modal').appendChild(exitYo);
  document.getElementsByClassName('page-wrap')[0].style.filter = 'blur(5px)';
}

function disableScrollToBody() {
  document.body.style.overflow = 'hidden';
}
class _PreviewModal extends Component {
  constructor(props) {
    super(props);
    this.len = 0;
    this.state = {
      page_length: 0,
      current_page: 1,
    };
    //
    // init contextfor callbacks
    this.closeCallBack = this.closeCallBack.bind(this);
    this.goNextCallBack = this.goNextCallBack.bind(this);
    this.goPreviousCallBack = this.goPreviousCallBack.bind(this);
  }

  componentWillMount() {
    document.body.style.overflow = 'auto';
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.preview === false && nextProps.preview === true) return true;

    if (nextState.current_page === this.state.current_page) {
      // if(!this.props.preview)return false;
      return true;
    }

    const pgNbr = getPageNumber(this.refs.modal_doc.scrollWidth);
    const a = getPageToMargin(nextState.current_page - 1);
    this.refs.modal_doc.style.marginLeft = a === 0 ? 0 : `${a}px`;
    this.refs.current_page.innerText = ` ${nextState.current_page} `;
    this.refs.total_page.innerText = ` ${pgNbr} `;
    // now to the better
    if (nextState.current_page < pgNbr) this.refs.to_the_right.style.display = 'block';// show right
    else this.refs.to_the_right.style.display = 'none';
    if (nextState.current_page > 1) this.refs.to_the_left.style.display = 'block'; // show left
    else this.refs.to_the_left.style.display = 'none';

    //
    document.getElementsByClassName('page-wrap')[0].style.filter = 'blur(5px)';
    document.body.style.overflow = 'hidden';
    document.querySelector('.lp-doc-container.lp-doc-modal').style.overflow = 'hidden';
    return false;
  }

  componentWillUpdate(nextProps, nextState) {
    window.modal = this.refs.modal_doc;
    window.c_page = this.refs.current_page;
    window.t_page = this.refs.total_page;
    if (this.refs.modal_doc) {
      nextState.page_length = getPageNumber(this.refs.modal_doc.scrollWidth);
    }
  }

  componentDidUpdate() {
    // show and hide the page number
    if (this.refs.modal_doc) {
      if (this.state.current_page < (getPageNumber(this.refs.modal_doc.scrollWidth) - 1)) this.refs.to_the_right.style.display = 'block';// show right
      else this.refs.to_the_right.style.display = 'none';
      if (this.state.current_page > 1) this.refs.to_the_left.style.display = 'block'; // show left
      else this.refs.to_the_left.style.display = 'none';
    }

    if (this.refs.modal_doc) {
      const pageNumber = getPageNumber(this.refs.modal_doc.scrollWidth);
      this.state.page_length = pageNumber;
      if (this.refs.total_page) this.refs.total_page.innerText = ` ${pageNumber}`;
    }
    if (this.props.is_modal) disableScrollToBody();
    //
    // displace tge shit
    if (this.refs.exit_yo) {
      placeModalInDOM(this.refs.exit_yo);
    }
    const nbrSys = {};
    // this one must change
    const numbers = document.querySelectorAll('#modal [num-auto], #modal [num-auto-pre]');
    // get the numbering system

    // console.log(numbers);
    for (let i = 0; i < numbers.length; i += 1) {
      const v = numbers[i];
      if (v && v.attributes && v.attributes.getNamedItem('num-auto')) {
        nbrSys[v.attributes.getNamedItem('num-auto').value] = 0;
      } else {
        nbrSys[v.attributes.getNamedItem('num-auto-pre').value] = 0;
      }
    }

    Object.keys(numbers).forEach((idx) => {
      const element = numbers[idx];
      if (element && element.attributes && element.attributes.getNamedItem('num-auto')) {
        const counter = element.attributes.getNamedItem('num-auto').value;
        nbrSys[counter] += 1;
        element.innerHTML = nbrSys[counter];
        // test if it's an article
        if (counter === 'articles') {
          // init all them
          Object.keys(nbrSys).forEach((sysIdx) => {
            if (sysIdx !== 'articles') nbrSys[sysIdx] = 0;
          });
        }
      } else if (element && element.attributes) {
        const counter = element.attributes.getNamedItem('num-auto-pre').value;
        element.innerHTML = nbrSys[counter];
      }
    });
  }

  goToPage(id) {
    if (id <= this.state.page_length || id > 0) {
      this.setState({
        current_page: id,
      });
    }
  }

  closeCallBack(target) {
    const cList = target.classList;
    if (cList.contains('lp-modal') || cList.contains('lpm-close') || cList.contains('lp-modal-content') || cList.contains('lp-doc-modal-container')) {
      this.props.toggle_screen();
      document.getElementsByClassName('page-wrap')[0].style.filter = 'none';
      document.body.style.overflow = 'auto';
    }
  }

  goNextCallBack() {
    const pgNbr = getPageNumber(document.getElementById('lp-doc-modal').scrollWidth);
    if (this.state.current_page < pgNbr) this.goToPage(this.state.current_page + 1);
  }

  goPreviousCallBack() {
    if (this.state.current_page > 1) this.goToPage(this.state.current_page - 1);
  }

  render() {
    // console.time('modal')
    return (this.props.preview
            && <div
              id="doc-preview"
              className="lp-modal"
              ref="exit_yo"
              onClick={(evt) => { this.closeCallBack(evt.target); }}
              style={this.props.is_full ? { filter: 'blur(14px)' } : {}}
              onCopy={e => e.preventDefault()}
              onCut={e => e.preventDefault()}
            >
              <div className="lp-doc-modal-container">
                <div className="lp-modal-content">
                  <span className="lpm-close icn-x" />
                  <div className="lp-doc-container lp-doc-modal" ref="ff_p" style={{ overflow: 'hidden' }}>
                    <div id="lp-doc-modal" ref="modal_doc" className="lp-doc" style={{ marginLeft: getPageToMargin(this.state.current_page - 1) }}>
                      <div className="page">
                        {this.props.views.map(idx => <PreviewRow
                          key={generateId1(4)}
                          idOut={idx[1]}
                          out={idx[0]}
                        />)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dm-count">
                  {_lp('Page')}
                  <span ref="current_page">
                    {' '}
                    {this.state.current_page}
                    {' '}
                  </span>
                  {_lp('sur')}
                  <span ref="total_page" />
                </div>
                {<button ref="to_the_right" className="lpm-next" onClick={this.goNextCallBack}>
                  <i className="icn-chev-llr" />
                </button>}
                {<button ref="to_the_left" className="lpm-prev" onClick={this.goPreviousCallBack}>
                  <i className="icn-chev-lll" />
                </button>}
              </div>
            </div>);
    // console.timeEnd('modal')
  }
}


const mapStateToProps = (state) => {
  // check the updatable conditions.
  numberOfAll = 0;
  const outputs = [];
  if (state.contract === undefined || state.contract === null) {
    return {
      views: [],
    };
  }
  if (!state.preview) {
    return {
      is_modal: state.preview,
      preview: state.preview,
      views: [],
    };
  }

  // console.log(keys)
  Object.keys(lpApp.indexes.real_sections.output_sections).forEach((idx) => {
    lpApp.ops.content.getOutput(lpApp.indexes.real_sections.getOutputSection(idx).options, outputs);
  });
  lpApp.indexes.content.updateContent(outputs, numberOfAll);

  return {
    preview: state.preview,
    views: outputs,
    is_modal: state.preview,
  };
};

const mapDispatchToProps = dispatch => ({
  toggle_screen: () => {
    dispatch(togglePreview());
  },
});

const PreviewModal = connect(mapStateToProps, mapDispatchToProps)(_PreviewModal);

export default PreviewModal;



// WEBPACK FOOTER //
// ./src/components/modal.js